import React, { useState } from "react";
import Text from "../atoms/Text";
import Icon from "../atoms/Icon";
import Input from "../molecules/Input";

export default function Newsletter() {
  const [email, setEmail] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    console.log("Newsletter email:", email);
    setEmail("");
  }

  return (
    <div className="newsletter" style={{ display: 'flex', flexDirection: 'row', gap: '100px',padding: '60px 300px', alignItems: 'center', backgroundColor: 'var(--greenG05)', borderTop: '1px solid var(--greenG1)', borderBottom: '1px solid var(--greenG1)' }}>
      <Icon
        src={require("../../assets/Logo.png")}
        size="width: '223px', height: '47px'"
      />
      <div style={{textAlign: 'start'}}>
        <Text
          size="px24"
          weight="w500"
          color="greenG9"
          extraStyles={{ lineHeight: "150%" }}
        >
          Subscribe To Our Newsletter
        </Text>
        <Text
          size="px14"
          weight="w400"
          color="greenG4"
          extraStyles={{ lineHeight: "150%" }}
        >
          Pellentesque eu nibh eget mauris congue mattis matti.
        </Text>
      </div>
      <form className="newsletter-form" onSubmit={handleSubmit}>
        <Input
          variant="withBtn"
          type="email"
          placeholder="Enter your email address"
          value={email}
          width="500px"
          onChange={(event) => setEmail(event.target.value)}
          buttonProps={{ type: "submit" }}
        />
      </form>
    </div>
  );
}
